import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  AddOnsComponent, AttendeesComponent, ConfirmationComponent,
  HangoutsComponent, PackagesComponent, TimeslotsComponent, WizardCheckoutStepComponent,
  WizardComponent, WizardFirstStepComponent, WizardGuestInfoComponent, WizardReviewStepComponent
} from '@unleashed/booking/components';
import { NotFoundComponent } from '@unleashed/booking/components/not-found/not-found.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'start' },
  {
    path: '',
    component: WizardComponent,
    children: [
      { path: 'start', component: WizardFirstStepComponent },
      // { path: 'start', component: StartComponent },
      { path: 'packages', component: PackagesComponent },
      { path: 'timeslots', component: TimeslotsComponent },
      { path: 'hangouts', component: HangoutsComponent },
      { path: 'addons', component: AddOnsComponent },
      { path: 'attendees', component: AttendeesComponent },
      { path: 'review', component: WizardReviewStepComponent },
      // { path: 'review', component: ReviewComponent },
      { path: 'guest-info', component: WizardGuestInfoComponent },
      { path: 'checkout', component: WizardCheckoutStepComponent },
      // { path: 'checkout', component: CheckoutComponent },
      { path: 'confirmation', component: ConfirmationComponent },
      { path: 'not-found', component: NotFoundComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BookingRoutingModule { }
